import { ref } from 'vue';
import { defineStore } from 'pinia';
import { cloneDeep } from 'lodash';

import type { RecipeMainIngredient } from '@apps/main/modules/recipe/ingredients';

import { useRecipeStore } from './recipeStore';

// NOTE:
// Purpose of this store is to keep previous recipe as the backup in case of wanting to restore previous state

export const useRecipeBackupStore = defineStore('RecipeBackupStore', () => {
  const recipeStore = useRecipeStore();

  const backupRecipe = ref<RecipeMainIngredient[]>([]);

  // Actions
  function createBackup(recipe?: RecipeMainIngredient[]): void {
    backupRecipe.value = cloneDeep(recipe || recipeStore.recipe);
  }

  function getBackup(): RecipeMainIngredient[] {
    return cloneDeep(backupRecipe.value);
  }

  function clearBackup(): void {
    backupRecipe.value = [];
  }

  function restoreBackup(shouldClearBackup = true): void {
    if (backupRecipe.value.length > 0) {
      recipeStore.recipe = getBackup();

      if (shouldClearBackup) {
        clearBackup();
      }
    }
  }
  return {
    // Actions
    clearBackup,
    createBackup,
    getBackup,
    restoreBackup,
  };
});
